import {UserDetailsMinRes} from '../cp';
import {Type} from 'class-transformer';
import {BaseTaskRes, ProjectMinRes} from '../crm';
import {OccurrenceRes} from './occurrence.contract';
import {DateRange} from '../../../services/date-range.service';

export class AppointmentRes {
    id!: number;
    @Type(() => UserDetailsMinRes)
    user!: UserDetailsMinRes;
    @Type(() => ProjectMinRes)
    project!: ProjectMinRes;
    rRule!: string;
    @Type(() => BaseTaskRes)
    baseTask!:BaseTaskRes
    durationInHours!:number;
}

export class AppointmentRangeRes extends AppointmentRes {
    occurrences: OccurrenceRes[] = []
}

export class AppointmentRangeReq {
    startRangeDate!: string;
    endRangeDate!: string;

    constructor(range:DateRange) {
        let start = new Date(range.start);
        let end = new Date(range.end);
        start.setUTCHours(0, 0, 0);
        start = new Date(start.setDate(start.getDate() -1))
        end.setUTCHours(0,0,0);
        end = new Date(end.setDate(end.getDate() + 1))

        this.startRangeDate = start.toISOString()
        this.endRangeDate = end.toISOString()
    }
}

export class AppointmentCreateReq extends AppointmentRangeReq {
    userId: number;
    projectId: number;
    rrule: string;
    durationInHours: number
    startDate: string;
    taskId: string

    constructor(userId: number, projectId: number, rrule: string, duration: number, startEvent: Date, range:DateRange, taskId: string) {
        super(range);
        this.userId = userId;
        this.projectId = projectId
        this.rrule = rrule
        this.durationInHours = duration
        startEvent.setUTCHours(0,0,0)
        this.startDate = startEvent.toISOString()
        this.taskId = taskId;

    }
}

export class AppointmentCollectionReq extends AppointmentRangeReq {
    appointments: AppointmentCreateReq[] = []
}